import React from 'react';
import { Button } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { WAREHOUSE_ROUTES } from 'constants/routes';
import ScribexERPLogo from '../../../../assets/icons/scribex-erp-logo.svg';

interface MobileHeaderProps {
  onMenuToggle: () => void;
}

export const MobileHeader: React.FC<MobileHeaderProps> = ({onMenuToggle}) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate(WAREHOUSE_ROUTES.inboundPackages);
  };

  return (
    <div className="mobile-header">
      <div className="mobile-header-content">
        <img
          src={ScribexERPLogo}
          alt="Scribex ERP Logo"
          className="mobile-logo"
          onClick={handleLogoClick}
          style={{cursor: 'pointer'}}
        />
        <Button type="text" icon={<MenuOutlined/>} onClick={onMenuToggle} className="mobile-menu-button"/>
      </div>
    </div>
  );
};
